export const FREE_CONSULTANCY_CATEGORY_CODE = "FREE_CONSULTANCY"

export const isFreeConsultancyService = service =>
  service?.categoryCode === FREE_CONSULTANCY_CATEGORY_CODE

export const getPricingFormValue = (service, price) =>
  isFreeConsultancyService(service) ? 0 : price

export const getSubmittedPricing = (service, price) =>
  isFreeConsultancyService(service) ? 0 : price

export const getPricingTableValue = pricingItem =>
  isFreeConsultancyService(pricingItem)
    ? 0
    : pricingItem?.pricing?.$numberDecimal ?? pricingItem?.pricing ?? 0

export const getServicePricingMetadata = service => ({
  ...(service?.categoryCode ? { categoryCode: service.categoryCode } : {}),
  ...(service?.consultationMode
    ? { consultationMode: service.consultationMode }
    : {}),
})
